module.exports = __webpack_public_path__ + "img/registration-step1.f0c2c135.webp";